import { stringify } from 'querystring'
import { serialize } from 'query-data'
import * as selectors from 'selectors'
import fetch from 'lib/fetch'

export const REQUEST_ACCOUNTS_BY_SOURCEID = 'REQUEST_ACCOUNTS_BY_SOURCEID'
export const RECEIVE_ACCOUNTS_BY_SOURCEID = 'RECEIVE_ACCOUNTS_BY_SOURCEID'
export const REQUEST_ACCOUNTS_BY_SOURCEID_ERROR = 'REQUEST_ACCOUNTS_BY_SOURCEID_ERROR'

export const fetchAccountsBySourceId = (sourceId, settings, workspaceId) => ({
  types: {
    request: REQUEST_ACCOUNTS_BY_SOURCEID,
    receive: RECEIVE_ACCOUNTS_BY_SOURCEID,
    failure: REQUEST_ACCOUNTS_BY_SOURCEID_ERROR
  },
  payload: { sourceId },
  shouldCallAPI (state) {
    const isRequesting = selectors.isRequestingAccountsBySourceId(state, sourceId)
    return !isRequesting
  },
  callAPI () {
    const query = stringify({ settings: serialize(settings), workspaceId })
    return fetch(`/api/accounts/${sourceId}?${query}`)
      .then(res => {
        if (!res.ok) {
          throw new Error('Unable to fetch accounts')
        }
        return res.json()
      })
      .then(data => data.accounts)
  }
})



// WEBPACK FOOTER //
// ./actions/accounts-by-sourceid.js